var playlist_block = (function( $ ) {

    var $blocks;

    var _init = function() {
        $blocks = $('.playlist-content-block');

        $blocks.each( ( index, item ) => {
            var $block = $( item );

            _setup_block( $block );
        } );
    };

    var _setup_block = function ( $block ) {
        var $play_links = $block.find('.playlist-item');

        $play_links.on( 'click', function ( e ) {
            e.preventDefault();

            var $link = $( this );

            if ( !$link.hasClass('playing') ) {
                _switch_active_player( $block, parseInt($link.data( 'index' ) ) );
            }
        })
    }

    var _switch_active_player = function ( $block, index ) {
        var $player = $block.find( '.player' ).first(),
            embeds  = $player.data( 'embeds' );

        $player.empty();
        $player.append( embeds[index] );

        $player.addClass( 'has-active-player' );

        $block.find( '.playlist-item.playing' ).removeClass( 'playing' );
        $block.find( '.playlist-item[data-index=' + index + ']' ).addClass( 'playing' );

        setTimeout(() => {
            $( [document.documentElement, document.body] ).animate({
                scrollTop: $player.offset().top - ( $( '#header' ).outerHeight() + 15 )
            }, 200 );
        }, 100 );
    }

    if ( $( '.playlist-content-block' ).length > 0 ) {
        $( document ).ready( _init );
    }

    return {};

})( jQuery );

module.exports = playlist_block;
